
import React from 'react'
import css from './ReceiptStamp.module.css'

const ReceiptStamp = () => (
  <div className={css.main} />
)

export default ReceiptStamp



// WEBPACK FOOTER //
// ./components/ReceiptStamp.js